<template>
  <div>
    <confirm-remove :showRemoveDialog="showRemoveDialog" @confirm="removeTag" @close="showRemoveDialog = false"></confirm-remove>
    <md-card class="card-container" v-if="isLoaded">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="isEditing ? '修改標籤' : '新增標籤'"></page-title>
        </div>
        <div class="md-layout-item float-right">
          <md-button v-if="isEditing" class="md-raised md-accent float-right" @click="showRemoveDialog = true">刪除標籤</md-button>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
            <md-checkbox v-model="data.dedicated">專任治療師</md-checkbox>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="$router.back()">返回</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="md-raised md-primary float-right" @click="isEditing ? editTag() : createTag()">送出</md-button>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import ConfirmRemove from '@/components/Shared/ConfirmRemove'
import axios from 'axios'
import urls from '@/urls'

export default {
  data () {
    return {
      isLoaded: false,
      showRemoveDialog: false,
      isEditing: null,
      data: {
        name: null,
        dedicated: false,
        tag_group: {
          id: null
        }
      },
      tagGroups: []
    }
  },
  components: {
    PageTitle, ConfirmRemove
  },
  created: async function () {
    this.data.tag_group.id = this.$route.params.groupID
    await this.getTagGroup()
    if (this.$route.params.id !== 'add') {
      this.isEditing = await this.$route.params.id
    }
    if (this.isEditing) {
      await this.readTag(this.isEditing)
    }
    this.isLoaded = true
  },
  methods: {
    readTag: async function (tagID) {
      let req = await axios.get(urls({route: 'tag', id: tagID}), this.data)
      this.data = req.data.data
    },
    editTag: async function () {
      let req = await axios.put(urls({route: 'tag', id: this.isEditing}), this.data)
      if (req.status === 200) {
        this.$router.back()
      }
    },
    createTag: async function () {
      let req = await axios.post(urls({route: 'tag'}), this.data)
      if (req.status === 201) {
        this.$router.back()
      }
    },
    getTagGroup: async function () {
      let req = await axios.get(urls({route: 'tag-group'}))
      this.tagGroups = req.data.data
    },
    removeTag: async function () {
      let req = await axios.delete(urls({route: 'tag', id: this.isEditing}))
      if (req.status === 201) {
        this.$router.back()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Tag/TagEdit.vue